import React from "react";

const STYLES = {
  pending: { bg: "hsl(45 95% 95%)", color: "hsl(40 95% 25%)", border: "hsl(45 90% 80%)", label: "Pending" },
  approved: { bg: "hsl(145 50% 95%)", color: "hsl(145 65% 22%)", border: "hsl(145 50% 80%)", label: "Approved" },
  rejected: { bg: "hsl(0 70% 96%)", color: "hsl(0 65% 35%)", border: "hsl(0 65% 85%)", label: "Rejected" },
  info_requested: { bg: "hsl(220 25% 95%)", color: "hsl(220 30% 30%)", border: "hsl(220 25% 85%)", label: "Info Needed" },
  reimbursed: { bg: "hsl(225 45% 20%)", color: "hsl(40 20% 97%)", border: "hsl(225 45% 20%)", label: "Reimbursed" },
};

export default function StatusPill({ status, testId }) {
  const s = STYLES[status] || STYLES.pending;
  return (
    <span
      data-testid={testId}
      className="status-pill"
      style={{ backgroundColor: s.bg, color: s.color, border: `1px solid ${s.border}` }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: s.color }} />
      {s.label}
    </span>
  );
}

export function PlanBadge({ plan }) {
  const map = {
    community: { bg: "hsl(40 10% 92%)", color: "hsl(220 30% 30%)", label: "Community" },
    growth: { bg: "hsl(45 85% 88%)", color: "hsl(40 95% 25%)", label: "Growth" },
    impact: { bg: "hsl(225 45% 20%)", color: "hsl(40 20% 97%)", label: "Impact" },
  };
  const s = map[plan] || map.community;
  return (
    <span
      className="status-pill"
      style={{ backgroundColor: s.bg, color: s.color }}
    >
      {s.label}
    </span>
  );
}
